export default __webpack_public_path__ + "static/media/app_tune_in.91bec922.svg";